import { makeStyles } from "@material-ui/core/styles";
import { createStyles, Typography } from "@material-ui/core";
import { BLUE_DARK, BLUE_LIGHT, REGULAR, WHITE } from "../helpers/constants";

export default function AboutUs() {
	const styles = useStyles();

	return (
		<div className={styles.container}>
			<Typography className={styles.firstSquare}>Quem Somos</Typography>
			<Typography className={styles.secondSquare}>
				A Souza Pilares se consolidou no mercado buscando atender as necessidades
				específicas dos seus clientes, garantindo segurança e agilidade na prestação de
				serviços. Nossa missão é garantir ao cliente total confiabilidade, oferecendo
				consultoria no ramo de seguros e benefícios, com soluções e serviços inovadores no
				mercado segurador, garantindo tranquilidade aos seus segurados.
			</Typography>
		</div>
	);
}

const useStyles = makeStyles(() =>
	createStyles({
		container: {
			paddingTop: "1%",
			display: "flex",
			flexDirection: "column",
			justifyContent: "start",
			alignItems: "center",
			width: "100%",
			backgroundColor: WHITE,
		},
		firstSquare: {
			display: "flex",
			color: BLUE_DARK,
			width: 250,
			minWidth: 200,
			whiteSpace: "nowrap",
			fontSize: 28,
			justifyContent: "center",
			alignItems: "center",
			fontFamily: REGULAR,
			fontWeight: "bold",
			borderStyle: "solid",
			borderWidth: 0,
			borderBottomWidth: 2,
			borderColor: BLUE_LIGHT,
			height: 20,
			padding: 30,
		},
		secondSquare: {
			display: "flex",
			color: BLUE_DARK,
			minWidth: 300,
			maxWidth: 600,
			fontSize: "120%",
			lineHeight: 1.2,
			textAlign: "center",
			justifyContent: "center",
			alignItems: "start",
			fontFamily: REGULAR,
			//fontWeight: 'bold',
			padding: 30,
		},
	})
);
